
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import Select from 'react-select';
import { API_BASE_URL, UPDATE_STAFF } from '../../../Config';
import SpinLoader from '../../../feature-module/loader/SpinLoader';

const EditStaff = ({ staffObj }) => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [formData, setFormData] = useState({});
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [selectedEmpType, setSelectedEmpType] = useState(null);
    const [selectedGender, setSelectedGender] = useState(null);

    useEffect(() => {
      const userDataString = sessionStorage.getItem("userData");
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        setUserDataSession(userData);
      } else {
        console.log("User data not found in sessionStorage");
      }
    }, []);

    useEffect(() => {
        if (staffObj) {
            setFormData({
                OrgId: userDataSession.OrgId,
                Id: staffObj.Id,
                Name: staffObj.Name,
                Code: staffObj.Code,
                MobileNo: staffObj.MobileNo,
                Type: staffObj.Type,
                UpdatedBy: userDataSession.UserId,
                IsActive: 1,
                Gender: staffObj.Gender
            });

            // Set the selected options for gender and employee type
            const selectedGenderOption = genderData.find(option => option.value === String(staffObj.Gender));
            const selectedEmpTypeOption = empTypes.find(option => option.value === String(staffObj.Type));

            setSelectedGender(selectedGenderOption);
            setSelectedEmpType(selectedEmpTypeOption);
        }
    }, [staffObj]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);

        console.log(formData, 'data sending to api');
        fetch(`${API_BASE_URL}${UPDATE_STAFF}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(response => response.json())
            .then(data => {
                console.log(data.ResultData[0], 'resposneeee');
                console.log(data.ResultData[0].Status === 'Success', 'resposneeee');
                setSubmitBtnLoading(false);
                if (data.ResultData[0].Status === 'Success') {
                    Swal.fire({
                        title: `Staff updated Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }
            })
            .catch(error => {
                setSubmitBtnLoading(false);
                console.error('Error updating category:', error);
            });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleEmpTypeChange = (selectedOption) => {
        setSelectedEmpType(selectedOption);
        setFormData(prevState => ({
            ...prevState,
            Type: selectedOption.value
        }));
    };

    const handleGenderChange = (selectedOption) => {
        setSelectedGender(selectedOption);
        setFormData(prevState => ({
            ...prevState,
            Gender: selectedOption.value
        }));
    };

    const empTypes = [
        { value: '1', label: 'Sales Representative' },
        { value: '2', label: 'Manager' },
        { value: '3', label: 'Staff' },
        { value: '4', label: 'Admin' },
    ];

    const genderData = [
        { value: '1', label: 'Male' },
        { value: '0', label: 'Female' },
    ];


    return (
        <div>
            {/* Edit Unit */}
            {submitBtnLoading&&(<SpinLoader/>)}
            <div className="modal fade" id="edit-staff">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Edit Staff</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close d-flex ms-auto"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className='row'>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder='Enter staff name'
                                                    name="Name"
                                                    value={formData.Name || ''}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Code</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder='Enter code'
                                                    name="Code"
                                                    value={formData.Code || ''}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Mobile No</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder='Enter mobile no'
                                                    name="MobileNo"
                                                    value={formData.MobileNo || ''}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Gender</label>
                                                <Select
                                                    options={genderData}
                                                    className="select"
                                                    placeholder="Choose"
                                                    value={selectedGender}
                                                    onChange={handleGenderChange}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Employee Type</label>
                                                <Select
                                                    options={empTypes}
                                                    className="select"
                                                    placeholder="Choose"
                                                    value={selectedEmpType}
                                                    onChange={handleEmpTypeChange}
                                                />
                                            </div>
                                            <div className="modal-footer-btn">
                                                <button
                                                    type="button"
                                                    className="btn btn-cancel me-2"
                                                    data-bs-dismiss="modal"
                                                     disabled={submitBtnLoading}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-submit"
                                                     disabled={submitBtnLoading}
                                                >
                                                    {submitBtnLoading ? 'Submitting..' : 'Submit'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
};

EditStaff.propTypes = {
    staffObj: PropTypes.object.isRequired,
};

export default EditStaff;
